module.exports = __webpack_public_path__ + "img/40_38_030_130.344f4766.jpg";